'use client'

import accountConfig from '@/feature/account/config/account.json'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Drawer, DrawerBody } from '@/ui/drawer/drawer/Drawer.client'
import { atom, useAtom } from 'jotai'
import NextImage from 'next/image'

type AccountConfig = typeof accountConfig & {
  billExamples?: string[]
}

const config = accountConfig as AccountConfig
const BILL_EXAMPLES = config.billExamples ?? []

export const hasBillExamples = BILL_EXAMPLES.length > 0

export const isBillExampleVisible = atom(false)

export function BillExampleDrawer() {
  const [isDrawerOpen, closeDrawer] = useAtom(isBillExampleVisible)
  const { t } = useTranslation(['billExampleDrawer'])

  if (BILL_EXAMPLES.length === 0) {
    return null
  }

  return (
    <Drawer
      isOpen={isDrawerOpen}
      onOpenChange={closeDrawer}
      title={t('billExampleDrawer:drawerTitle', { count: BILL_EXAMPLES.length })}
    >
      <DrawerBody>
        <div className="flex h-auto w-full flex-col gap-3">
          {BILL_EXAMPLES.map((imageName, index) => (
            <div key={imageName} className="flex flex-col gap-1">
              {/* Next.js Image pattern for responsive images: width/height=0 + sizes lets CSS control dimensions */}
              <NextImage
                className="h-auto w-full"
                src={`/media/image/bill-examples/${imageName}`}
                alt={t('billExampleDrawer:imageAlt', { label: index + 1 })}
                width={0}
                height={0}
                sizes="100vw"
              />
              {BILL_EXAMPLES.length > 1 && (
                <span>{t('billExampleDrawer:imageLabel', { label: index + 1 })}</span>
              )}
            </div>
          ))}
        </div>
      </DrawerBody>
    </Drawer>
  )
}
